import { slateToHtml } from './slate-to-html';

/**
 * Whether stored rich-text content renders as empty.
 *
 * Accepts both formats handled during the RichTextEditor → TextEditor migration: legacy Slate JSON
 * and HTML. The content is normalized to HTML, then tags and whitespace are stripped to check
 * whether any visible text remains.
 */
export const isRichTextEditorContentEmpty = (content?: string | null): boolean => {
  const text = slateToHtml(content)
    .replace(/<[^>]*>/g, '') // strip tags
    .replace(/&nbsp;/gi, '') // strip non-breaking spaces
    .trim();

  return text === '';
};
